import { IState } from 'angular-ui-router';
import { AuthService } from 'phoenix/services';
export const loginParentRoute = 'loginComponent';
// inject cross-cutting functionality into all login controllers
let createLoginController = generateCrossCuttingController(['$scope', $scope => {
	if($scope.$parent && $scope.$parent.vm) {
		$scope.$parent.vm.visible = true;
	}
}]);

export const routes:IState[] = [{
	name:'login', 
	parent: loginParentRoute,
	url: '/login',
	params: {
		errorMessage: null
	},
	template: '<px-login-main error-message="vm.sharedObjects.message" email-address="vm.sharedObjects.emailAddress" />',
	controller: ['$scope', 'pxAuthInterceptor', 'pxAuthService', ($scope, pxAuthInterceptor, pxAuthService:AuthService) => {
		if($scope.$parent && $scope.$parent.vm) {
			$scope.$parent.vm.visible = !pxAuthService.rememberedEmail;
		}

		if(pxAuthService.isAuthenticated) {
			pxAuthInterceptor.redirectPostLogin();
		} 	
	}]
}, {
	//passwordcallback?auth=MDAwMDAwMDI6NDE5MjQyZDctMjAwNC00ZjVlLWFiNDctZTczMTY4N2JlYzMz
	name:'passwordCallback', 
	parent: loginParentRoute,
	url: '/passwordcallback?auth', 
	template: '<px-login-reset-password error-message="vm.sharedObjects.message" />',
	controller: createLoginController(['$state', '$stateParams', ($state, $stateParams) => {
		// State params must contain emailAddress in order to route
		if (!angular.isString($stateParams.auth)) {
			$state.go('login');
		}
	}])
}, {
	name: 'idpCallback', 
	parent: loginParentRoute,
		url: '/idpCallback?access_token&id_token&token_type&state&expires_in&scope&session_state&error',
		template: '<px-login-idp-callback />',
		// this state should not unhide the UI using the cross-cutting controller
		controller: ['$scope', '$state', '$stateParams', ($scope, $state, $stateParams) => {
			// State params must contain a token in order to login
			if (!angular.isString($stateParams.id_token)) {
				$state.go('login');
			}
		}]
}, {
	//register/:deploymentId/setpassword?auth=MDAwMDAwMDI6NDE5MjQyZDctMjAwNC00ZjVlLWFiNDctZTczMTY4N2JlYzMz
	name: 'loginRegister',
	parent: loginParentRoute,
	url: '^/register/:deploymentId/setpassword?auth',
	template: function(params) {
		return `<px-login-register error-message="vm.sharedObjects.message" deployment-id="${params.deploymentId}" auth-token="${params.auth}" />`;
	},
	controller: createLoginController()
}, {
	name: 'registerUser',
	parent: loginParentRoute,
	url: '^/registration?auth&email&username',
	template: params => {
		if (!params.username) {
			params.username = '';
		}
		
		return `<px-login-register-user error-message="vm.sharedObjects.message" auth-token="${params.auth}" email="${params.email}" username="${params.username}" />`;
	},
	controller: createLoginController()
}];


// Decorator function that accepts an Angular DI list and generates 
// a partially-applied function which itself accepts a DI list.  
// Dependency lists will be merged and resolved all at once  
// when called later by the UI router framework.
function generateCrossCuttingController(crossCutting:any[]) {
	let ccController:(...args) => void = crossCutting.pop();
	let ccDiList:string[] = crossCutting;

	return (diList:any[] = []) => {
		if(angular.isFunction(diList[diList.length - 1])) {
			let controller:(...args) => void = diList.pop();
			let originalDiList:string[] = diList;
			let resolveAll = (...deps) => {
				let ccDeps = deps.slice(0, ccDiList.length);
				deps = deps.slice(ccDiList.length)

				ccController.apply(this, ccDeps);
				controller.apply(this, deps);
			}

			diList = ccDiList.concat(diList);
			diList.push(resolveAll);;
		}
		else {
			diList = ccDiList.concat(ccController as any);
		}

		return diList;
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/components/login/login.routes.ts